import { Component, OnInit } from '@angular/core';
import { TwoWayBoundComponent } from '@app/shared/components/base/two-way-bound.component';
import { ClientUser } from '@app/shared/models/client-user';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { UntypedFormControl, Validators } from '@angular/forms';


@Component({
    selector: 'user-address',
    templateUrl: './user-address.component.html'
})
export class UserAddressComponent extends TwoWayBoundComponent<ClientUser>
                                  implements OnInit {

    public user_code: UntypedFormControl;

    constructor() {
        super();
    }

    public ngOnInit() {
        super.ngOnInit();

        this.user_code = new UntypedFormControl(
            {
                value: this.bananaBox.user_code,
                disabled: this.disabled
            },
            {
                updateOn: 'blur',
                validators: [Validators.required],
            });
    }

    public getUserCodeError(): string {
        return this.user_code.hasError('required') ? marker('user_management.error.user_code.required') :
            '';
    }

    public valid(andTouch?: boolean): boolean {
        if (this.user_code) {
            if (andTouch) {
                this.user_code.markAsTouched();
            }

            return !this.user_code || !this.user_code.touched || !this.user_code.invalid;
        } else {
            return true;
        }

    }
}
